import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col, Form, Container, Spinner } from 'react-bootstrap';
import {
    uploadImages
} from '../../../common/Utilities'
import {
    getMobileAppBanner,
    resetMobileAppBanner,
    upsertMobileAppBanner,
    handleInputChange
} from '../../../store/actions/mobileappbanner/mobileAppBannerActions'
import { PUBLISHED, DRAFT } from '../../../store/actions/posts/postsActions';
import ProgressingButton from '../../../common/ProgressingButton'
import { setIsSaving } from '../../../store/actions/commonActions'

import PageTitle from '../../../common/PageTitle';

class MobileAppBannerForm extends Component {

    constructor(props) {
        super(props);
        this.pathname = this.props.location.pathname;
        this.title = 'Add Mobile App Banner';
        this.isReady = false;
    }

    async componentDidMount() {

        if (this.pathname === '/mobile-app-banner/edit') {
            const urlParams = new URLSearchParams(this.props.location.search);
            const id = urlParams.get('id');
            await this.props.getMobileAppBanner(id);
            this.title = 'Edit Mobile App Banner';
        }

        //handle saving unchecked
        this.props.handleInputChange(null, {
            status: DRAFT
        });
    }

    uploadImage = (e) => {
        this.props.setIsSaving(true);
        return uploadImages(e)
            .then(image_url => {
                console.log(image_url);
                if (image_url) {
                    this.props.handleInputChange(null, {
                        image_url
                    });
                }
            })
            .finally(() => {
                this.props.setIsSaving(false);
            })
            .catch(e => { console.log(e) })
    }

    componentWillUnmount() {
        this.props.resetMobileAppBanner();
    }

    render() {

        const mobileappbanner = this.props.mobileappbanners.mobileappbanner;

        let image_url;
        if (mobileappbanner.image_url) {
            image_url = <img src={mobileappbanner.image_url} alt={mobileappbanner.image_url} />
        }
        if (this.props.common.isSaving) {
            image_url = <Spinner animation="border" size="sm" />
        }

        if (!this.isReady && (mobileappbanner.id || this.pathname !== '/mobile-app-banner/edit')) {
            this.isReady = true;
        }

        return this.isReady ? (
            <div>
                <Container className="waa-container">
                    <PageTitle pageName={this.title} />
                    <hr />
                    <Col>
                        <Form className="waa-form">
                            <Form.Group controlId="formScreenLabel">
                                <Form.Label>External Url</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={mobileappbanner.external_url}
                                    onChange={(e) => {
                                        this.props.handleInputChange(null, {
                                            external_url: e.target.value
                                        });
                                    }}
                                />
                            </Form.Group>
                            <Form.Group controlId="formCheckbox">
                                <Form.Check
                                    type="checkbox"
                                    label="Published"
                                    defaultChecked={mobileappbanner?.status === PUBLISHED}
                                    onChange={e => {
                                        this.props.handleInputChange(null, {
                                            status: e.target.checked ? PUBLISHED : DRAFT
                                        });
                                    }}
                                />
                            </Form.Group>
                            <Form.Group controlId="formImage" className='banner-upload-container'>
                                <Form.Label>
                                    Upload Banner File<br />
                                    {image_url}
                                </Form.Label>
                                <Form.Control
                                    type="file"
                                    accept=".jpg, .jpeg, .png, .gif"
                                    onChange={this.uploadImage}
                                    className='banner-input-upload'
                                />
                                <Form.Label className='banner-text-note'>File size limit: 10 MB (jpeg, jpg, png, gif)</Form.Label>
                            </Form.Group>



                            <ProgressingButton
                                className="save-button"
                                type="submit"
                                variant="primary"
                                onClick={this.props.upsertMobileAppBanner}
                                buttonValue="Save" />
                        </Form>
                    </Col>
                </Container>
            </div>
        ) : <Spinner animation="border" size="sm" />
    }
}

const mapStateToProps = (state) => ({
    users: state.users,
    mobileappbanners: state.mobileappbanners,
    common: state.common
})

const mapDispatchToProps = (dispatch) => {
    return {
        getMobileAppBanner: (...args) => dispatch(getMobileAppBanner(...args)),
        resetMobileAppBanner: (...args) => dispatch(resetMobileAppBanner(...args)),
        upsertMobileAppBanner: (...args) => dispatch(upsertMobileAppBanner(...args)),
        handleInputChange: (...args) => dispatch(handleInputChange(...args)),
        setIsSaving: (...args) => dispatch(setIsSaving(...args)),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MobileAppBannerForm))
